import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { markPrinted, markNotPrinted } from '../modules/orders'

import component from 'components/Orders/Process'

const mapActionCreators = {
  markPrinted,
  markNotPrinted
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(mapActionCreators, dispatch),
  dispatch
})

const mapStateToProps = (state, ownProps) => ({
  pricelist: state.pricelist,
  orders: state.orders,
  routes: state.routes,
  customers: state.customers,
  options: state.options,
  uoms: state.uoms,
  date: ownProps.params.date || 'today'
})

export default connect(mapStateToProps, mapDispatchToProps)(component)



// WEBPACK FOOTER //
// ./src/routes/Orders/containers/ProcessContainer.js